import styles from "./Legal.module.css";

function Legal() {

	return (
		<div className={styles.legalPageContainer}>
			<h2 className="title">Qui sommes-nous&nbsp;?</h2>
			<p>
				L’adresse de notre site est&nbsp;:&nbsp;
				<a href="http://www.mescadeauxgratuits.com/" className={styles.link}>
					www.mescadeauxgratuits.com
				</a>
				.
			</p>
			<h2 className="title">Utilisation des données personnelles collectées</h2>
			<h2 className="sub-title">Formulaires de contact &amp; Cookies</h2>
			<p>
				Si vous déposez un formulaire de contact sur notre site, il vous sera
				proposé d’enregistrer votre nom, adresse de messagerie et site web dans
				des cookies. C’est uniquement pour votre confort afin de ne pas avoir à
				saisir ces informations si vous déposez un autre formulaire plus tard.
				Ces cookies expirent au bout d’un an.
			</p>
			<p>
				Si vous avez un compte et que vous vous connectez sur ce site, un cookie
				temporaire sera créé afin de déterminer si votre navigateur accepte les
				cookies. Il ne contient pas de données personnelles et sera supprimé
				automatiquement à la fermeture de votre navigateur.
			</p>
			<p>
				Lorsque vous vous connecterez, nous mettrons en place un certain nombre
				de cookies pour enregistrer vos informations de connexion et vos
				préférences d’écran. La durée de vie d’un cookie de connexion est de
				deux jours, celle d’un cookie d’option d’écran est d’un an.
			</p>
			<p>
				En modifiant ou en publiant un article, un cookie supplémentaire sera
				enregistré dans votre navigateur. Ce cookie ne comprend aucune donnée
				personnelle. Il indique simplement l’identifiant de l’article que vous
				venez de modifier. Il expire au bout d’un jour.
			</p>
			<h2 className="sub-title">Contenu embarqué depuis d’autres sites</h2>
			<p>
				Les articles de ce site peuvent inclure des contenus intégrés (par
				exemple des vidéos, images, articles…). Le contenu intégré depuis
				d’autres sites se comporte de la même manière que si le visiteur se
				rendait sur cet autre site.
			</p>
			<p>
				Ces sites web pourraient collecter des données sur vous, utiliser des
				cookies, embarquer des outils de suivis tiers, suivre vos interactions
				avec ces contenus embarqués si vous disposez d’un compte connecté sur
				leur site web.
			</p>
			<h2 className="sub-title">
				Utilisation et transmission de vos données personnelles
			</h2>
			<p>
				Durées de stockage de vos données Si vous laissez un commentaire, le
				commentaire et ses métadonnées sont conservés indéfiniment. Cela permet
				de reconnaître et approuver automatiquement les commentaires suivants au
				lieu de les laisser dans la file de modération.
			</p>
			<p>
				Pour les utilisateurs et utilisatrices qui s’enregistrent sur notre
				site, nous stockons également les données personnelles indiquées dans
				leur profil. Tous les utilisateurs et utilisatrices peuvent voir,
				modifier ou supprimer leurs informations personnelles à tout moment. Les
				gestionnaires du site peuvent aussi voir et modifier ces informations.
			</p>
			<h2 className="sub-title">Les droits que vous avez sur vos données</h2>
			<p>
				Si vous avez un compte ou si vous avez laissé des coordonnées sur le
				site, vous pouvez demander à recevoir un fichier contenant toutes les
				données personnelles que nous possédons à votre sujet, incluant celles
				que vous nous avez fournies. Vous pouvez également demander la
				suppression des données personnelles vous concernant. Cela ne prend pas
				en compte les données stockées à des fins administratives, légales ou
				pour des raisons de sécurité. Pour demander le fichier contenant vos
				informations, merci de nous contacter par mail à l’adresse :&nbsp;
				<a href="mailto:contact@mescadeauxgratuits.com" className={styles.link}>
					contact@mescadeauxgratuits.com
				</a>
				.
			</p>
			<h2 className="sub-title">Transmission de vos données personnelles</h2>
			<p>
				Les commentaires des visiteurs peuvent être vérifiés à l’aide d’un
				service automatisé de détection des commentaires indésirables.
			</p>
			<h2 className="sub-title">Informations de contact</h2>
			<p>
				Pour votre droit d’accès, la modification, ou la suppression de vos
				données, merci de nous contacter à l’adresse mail suivante :&nbsp;
				<a href="mailto:contact@mescadeauxgratuits.com" className={styles.link}>
					contact@mescadeauxgratuits.com
				</a>
				.
			</p>
			<h2 className="sub-title">Informations supplémentaires</h2>
			<p>
				Lorsque vous consentez à l’utilisation de vos données personnelles, vos
				données personnelles fournies dans les formulaires seront utilisées afin
				de vous contacter. Cas de la page témoignages : les informations
				collectées nous servent à améliorer nos services, en sachant quand et
				dans quel établissement vous avez été invité, et vos informations de
				contact afin de vous contacter pour une quelconque raison.
			</p>
			<h2 className="sub-title">Comment nous protégeons vos données</h2>
			<p>
				En fournissant vos informations personnelles, vous nous autorisez à
				utiliser les données collectées dans le but de respecter nos engagements
				envers vous et de vous fournir le service que vous attendez. Nous ne
				conserverons vos données que le temps nécessaire à accomplir nos
				services ou dans les limites prescrites par la loi. À l’issue de ce
				délai, vos données personnelles seront supprimées.
			</p>
			<h2 className="title">
				Les services tiers qui nous transmettent des données
			</h2>
			<h2 className="sub-title">Google Analytics</h2>
			<p>
				Opérations de marketing automatisé et/ou de profilage réalisées à l’aide
				des données personnelles
			</p>
			<p>
				Mes Cadeaux Gratuit peut être amené pour des opérations de marketing qui
				lui sont propres à utiliser vos données pour vous proposer des produits
				et des promotions qui pourraient vous convenir. Mes Cadeaux Gratuit ne
				vend ni ne communique vos données à des entreprises extérieures.
			</p>
			<h2 className="sub-title">Mes Cadeaux Gratuit</h2>
			<p>
				Mes Cadeaux Gratuit est une marque déposée auprès de l’lNPI, utilisée par
				la société HILL SMART. La marque a pour objet:
			</p>
			<ul>
				<li>
					Produits et services Publicité ; gestion des affaires commerciales ;
					administration commerciale ; travaux de bureau ; diffusion de matériel
					publicitaire (tracts, prospectus, imprimés, échantillons) ; services
					d’abonnement à des journaux (pour des tiers) ; services d’abonnement à
					des services de télécommunications pour des tiers ; conseils en
					organisation et direction des affaires ; comptabilité ; services de
					photocopie ; services de bureaux de placement ; portage salarial ;
					service de gestion informatisée de fichiers ; optimisation du trafic
					pour des sites internet ; organisation d’expositions à buts
					commerciaux ou de publicité ; publicité en ligne sur un réseau
					informatique ; location de temps publicitaire sur tout moyen de
					communication ; publication de textes publicitaires ; location
					d’espaces publicitaires ; diffusion d’annonces publicitaires ;
					conseils en communication (publicité) ; relations publiques ; conseils
					en communication (relations publiques) ; audits d’entreprises
					(analyses commerciales) ; services d’intermédiation commerciale.
				</li>
			</ul>
			<h3 className="title">HILL SMART, SLU</h3>
			<p>Numéro de registre de société 16576</p>
			<p>NRT : L-711685-M</p>
			<p>CARRER PRAT DE LA CREU 59 65</p>
			<p>ESCALA C, DESPATX 3B</p>
			<p>AD500 ANDORRA-LA-VELLA, PRINCIPAT D’ANDORRA</p>
			<p>
				<span className="minor-title">
					Contact principal et nom de la personne responsable des affaires
					juridiques dans l’entreprise&nbsp;:&nbsp;
				</span>
				Jean-Philippe PALOMINO
			</p>
			<p>
				<span className="minor-title">
					Numéro de téléphone de l’entreprise&nbsp;:&nbsp;
				</span>
				+376 878 877
			</p>
			<p>
				<span className="minor-title">
					Adresse email de l’entreprise&nbsp;:&nbsp;
				</span>
				<a href="mailto:conta@hill-smart.com" className={styles.link}>conta@hill-smart.com</a>
			</p>
		</div>
	);
}

export default Legal;
